import React, { useState } from "react";
import PostHooks from "../../../Api/PostHooks";
import AlertComponent from "../../../Components/AlertComponent";
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
  Typography,
} from "@mui/material";
import { MuiTelInput } from "mui-tel-input";
import { Controller, useForm } from "react-hook-form";
import { LoadingButton } from "@mui/lab";

const DepositForm = ({ user, onClose, onSuccess }) => {
  const {
    watch,
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const msisdn = watch("msisdn");

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const [depositLoading, depositResponse, depositRequest] = PostHooks();

  const onDeposit = async (e) => {
    try {
      if (msisdn === undefined || (msisdn && msisdn.length < 13)) {
        setSnackbar({
          open: true,
          severity: "error",
          message: "Please enter a valid phone number.",
        });
      } else {
        let formData = {
          amount: e.amount,
          msisdn: msisdn.replace("+", ""),
          entity_id: user.document_number,
        };

        const deposResp = await depositRequest({
          url: "/stktest",
          body: formData,
        });

        console.log("deposResp", deposResp);

        if (
          deposResp &&
          deposResp.status === 200 &&
          deposResp.data.ResultCode === 0
        ) {
          setSnackbar({
            open: true,
            severity: "success",
            message: "Deposit initiated, check phone!",
          });

          setTimeout(() => {
            onClose();
            onSuccess();
          }, 500);
        } else {
          const errorMessage =
            deposResp?.data?.StatusMessage ??
            deposResp?.data?.message ??
            "An unexpected error occurred. Please try again.";

          setSnackbar({
            open: true,
            severity: "error",
            message: errorMessage,
          });
        }
      }
    } catch (error) {
      console.log("deposit err", error);
      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.response?.data?.message ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  return (
    <form onSubmit={handleSubmit(onDeposit)}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <FormControl fullWidth>
        <Controller
          name="msisdn"
          control={control}
          render={({ field }) => (
            <MuiTelInput
              sx={{
                border: "1px solid black",
              }}
              defaultCountry="KE"
              disableFormatting
              value={msisdn}
              // onChange={(e) => setMsisdn(e)}
              {...field}
            />
          )}
        />
      </FormControl>

      <FormControl
        fullWidth
        error={!!errors.amount}
        sx={{
          mt: "20px",
        }}
      >
        <InputLabel htmlFor="amount">Amount</InputLabel>
        <OutlinedInput
          id="amount"
          type="amount"
          {...register("amount", { required: true })}
          label="Username"
        />
        {errors.amount && (
          <FormHelperText>Please enter an amount!</FormHelperText>
        )}
      </FormControl>

      <FormHelperText>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ mt: 1, display: "block" }}
        >
          This will send an STK push to {user.msisdn}.
        </Typography>
      </FormHelperText>

      <Box
        sx={{
          pt: "40px",
          gap: 2,
          display: "flex",
          direction: "row",
          justifyContent: "flex-end",
        }}
      >
        <Button type="reset" variant="text" onClick={onClose}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          type="submit"
          loading={depositLoading}
        >
          Submit
        </LoadingButton>
      </Box>
    </form>
  );
};

export default DepositForm;
